<div class="small-chart-widget chart-widgets-small">
   <div class="card">
     <div class="card-header">
       <h5>{{ 'Uses' | translate }}</h5>
     </div>
     <div class="card-body">
       <div class="chart-container">
         <div class="row">
           <div class="col-12">
             <div id="chart-widget9">
               <apx-chart [chart]="uses.chart" [dataLabels]="uses.dataLabels" [series]="uses.series" [fill]="uses.fill" [colors]="uses.colors" [title]="uses.title" [xaxis]="uses.xaxis" [yaxis]="uses.yaxis"></apx-chart>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>